import {MainVideoState} from "../definitions/MainVideoState";
import {PayloadAction} from "@reduxjs/toolkit";
import {ProjectInformation} from "../definitions/ProjectInformation";

export const projectsLoaded = (state: MainVideoState, action: PayloadAction<ProjectInformation[]>) => {
    state.projectState.availableProjects = action.payload;
};
